export default __webpack_public_path__ + "static/media/ubi-store-logo.35702912.svg";